<template>
  <colgroup class="calendar-cols">
    <col class="year-col" />
    <col v-for="month in monthNames" :key="month" />
  </colgroup>
</template>

<script setup>
import { monthNames } from "../../lib/helpers";
</script>

<style lang="scss">
  colgroup.calendar-cols {
    col.year-col {
      width: 65px;
    }
  }
</style>